module.exports = __webpack_public_path__ + "h5assets/img/guide_upload.372bd07.png";